import { render, staticRenderFns } from "./NuevoTraficoComponent.vue?vue&type=template&id=32eee933&"
import script from "./NuevoTraficoComponent.vue?vue&type=script&lang=js&"
export * from "./NuevoTraficoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports